module.exports = __webpack_public_path__ + "img/Logo-Icon.51aa0895.png";